<template>
  <div
      class="relative w-full border border-light/40 bg-base-100 rounded-xl p-4 flex flex-col gap-4 transition hover:bg-base-200 group cursor-pointer"
      @dragover.prevent="dragOver = true"
      @dragleave.prevent="dragOver = false"
      @drop.prevent="handleDrop"
      :class="{ 'border-accent bg-accent/10': dragOver }"
  >
    <!-- Uploaded Files List -->
    <div v-if="files.length" class="max-h-[120px] overflow-y-auto border-b border-base-300 pb-2 px-1">
      <div
          v-for="(file, index) in files"
          :key="file"
          class="text-sm flex items-center justify-between py-1 gap-2"
      >
        <span class="truncate">{{ file }}</span>
        <button @click.stop="removeFile(index)" class="text-error hover:text-error/80">
          <i class="bi bi-x-lg text-sm"></i>
        </button>
      </div>
    </div>

    <!-- Upload Prompt -->
    <div
        class="flex flex-col items-center justify-center text-center gap-2 cursor-pointer"
        @click="openFileDialog"
    >

      <div class="text-xl text-light shadow-sm shadow-light rounded-lg py-2 px-3 group-hover:text-accent">
        <i class="bi bi-flag"></i>
      </div>
      <p class="text-sm">
        <span class="font-medium text-accent group-hover:underline">Click to upload</span> or drag and drop
      </p>
      <p class="text-xs text-base-content/50">
        {{ acceptText }}
      </p>
    </div>

    <!-- Hidden Native Input -->
    <input
        ref="fileInput"
        type="file"
        class="hidden"
        :accept="accept"
        multiple
        @change="handleFiles"
    />
  </div>
</template>

<script setup>
import {computed, ref} from 'vue'

const props = defineProps({
  accept: {type: String, default: 'image/png, image/jpeg, image/svg+xml, image/gif'},
  acceptText: {
    type: String,
    default: 'SVG, PNG, JPG or GIF (max. 800×400px)'
  },
  modelValue: {type: Array, default: () => []} // ✅ enable v-model
})

const emit = defineEmits(['update:modelValue'])

const fileInput = ref(null)
const dragOver = ref(false)

const files = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})

function openFileDialog() {
  fileInput.value?.click()
}

function handleFiles(event) {
  const selectedFiles = [...event.target.files]
  const newFilenames = selectedFiles.map(file => file.name)
  files.value = [...new Set([...files.value, ...newFilenames])]
  event.target.value = ''
}

function handleDrop(event) {
  dragOver.value = false
  const droppedFiles = [...event.dataTransfer.files]
  const newFilenames = droppedFiles.map(file => file.name)
  files.value = [...new Set([...files.value, ...newFilenames])]
}

function removeFile(index) {
  const updated = [...files.value]
  updated.splice(index, 1)
  files.value = updated
}
</script>